import axios from 'axios';
import Api from '@/services/endpoint/tenant.service'
import {
    authRead
} from '@/store/auth.js';

let token = authRead();
console.log('token: ', token);
axios.defaults.headers.common[
    "Authorization"
] = `Bearer ${token}`;


/** SaleContact */
/** GET */
export const index = () => {
    return `/app/variations/index`;
};

export const getSaleContactAdvance = async(id) => {
    try {
        const resp = await Api.Setting.getSaleContactById(id);
        return resp.data;
    } catch (err) {
        console.error(err);
    }
};


/** POST */
export const createSaleContact = async(data) => {
    try {
        const resp = await Api.Setting.postSaleContact(data);
        return resp;
    } catch (err) {
        if(err.response.data.message.indexOf("You can not active plan feature") != -1){
            return 'not active plan';
        }else{
            console.error(err);
        }
    }
};

export const updateSaleContact = async(data, id) => {
    try {
        const resp = await Api.Setting.putSaleContact(data, id);
        if (resp.status === 200) {
            return resp;
        }
    } catch (err) {
        if(err.response.data.message.indexOf("You can not active plan feature") != -1){
            return 'not active plan';
        }else{
            console.error(err);
        }
    }
};

export const deleteSaleContact = async(id) => {
    try {
        const resp = await Api.Setting.deleteSaleContact(id);
        return resp.data;
    } catch (err) {
        if(err.response.data.message.indexOf("You can not active plan feature") != -1){
            return 'not active plan';
        }else{
            console.error(err);
        }
    }
};

/** Common */
/** GET */






// WEBPACK FOOTER //
// ./src/components/tenancy/admin/settings/sale/sale-contact/api/axios.js